import * as R from 'ramda';
import React, { useCallback, useEffect, useState } from 'react';
// helpers/constants
import * as G from '../../../helpers';
// utilities
import { sendRequest } from '../../../utilities/http';
import endpointsMap from '../../../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncLoadNotes = (initialProps) => {
  const [asyncNotes, setAsyncNotes] = useState(null);

  const getLoadNotesRequest = useCallback(async (props) => {
    const { loadGuid, loadType } = props;
  
    const params = { loadGuid };

    const endpoint = G.ifElse(
      G.isLoadTypeClo(loadType),
      endpointsMap.cloNoteList,
      endpointsMap.telNoteList,
    );

    const res = await sendRequest('get', endpoint, { params });

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      setAsyncNotes(R.or(data, []));
    } else {
      G.handleFailResponseSimple(
        res,
        false,
        'withAsyncLoadNotes -> getLoadNotesRequest',
      );
    }
  }, []);

  useEffect(() => {
    getLoadNotesRequest(initialProps);
  }, []);

  return { asyncNotes, getLoadNotesRequest };
};

export const withAsyncLoadNotes = (Component) => (props) => {
  const { loadGuid, loadType } = props;

  const { asyncNotes, getLoadNotesRequest } = useAsyncLoadNotes({ loadGuid, loadType });

  return (
    <Component
      {...props}
      asyncNotes={asyncNotes}
      getLoadNotesRequest={getLoadNotesRequest}
    />
  );
};
